<template>
    <div>
      <v-card class="rounded-xl" elevation="5">
        <v-card-title>
          <v-icon left>
            mdi-map-marker
          </v-icon>
          <span>Address</span>
          <v-spacer></v-spacer>
          <v-btn @click="openDialog" fab x-small elevation="0" dark color="success"><v-icon dark>mdi-pencil</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <label>Door No.</label>
              <h4>{{mbr.person.postalAddress.doorNumber}}</h4>
            </v-col>
            <v-col cols="6">
              <label>Street</label>
              <h4>{{mbr.person.postalAddress.street}}</h4>
            </v-col>
            <v-col cols="6">
              <label>Place</label>
              <h4>{{mbr.person.postalAddress.place}}</h4>
            </v-col><v-col cols="6">
              <label>City</label>
              <h4>{{mbr.person.postalAddress.city}}</h4>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogIsOpen">
        <!-- v-on="$listeners" to pass showResponse from parent -->
        <AddressDetailsForm :mbr="mbr" @closeDialog="closeDialog" v-on="$listeners"/>
      </v-dialog>
    </div>
  </template>
  <script>
  export default {
    components:{
        AddressDetailsForm:()=>import("@/components/wesupport/member/addressDetails/AddressDetailsForm.vue")
    },
    data: () => ({
      dialogIsOpen: false,
    }),
    props:{
      mbr:Object,
    },
    mounted() {
  
    },
    methods: {
      openDialog() {
        this.dialogIsOpen = true;
      },
      closeDialog() {
        this.dialogIsOpen = false;
      },
    },
  };
  </script>
  